var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slot-machine",on:{"click":_vm.startRolling}},[_c('div',{ref:"slotList",staticClass:"slot-list"},_vm._l((_vm.arrayList),function(item,index){return _c('div',{key:index,staticClass:"slot-item",style:({
        backgroundImage: ("url('" + (item.img) + "')"),
      }),attrs:{"id":item.id}},[_c('img',{attrs:{"src":item.imageUrl,"alt":"","srcset":""}})])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }